export default __webpack_public_path__ + "static/media/empty.4eb861e6.png";